import React, { useState } from 'react';
import {
  countryOptions,
  extractCountryCode,
  validatePhoneNumber,
  stripCountryCode
} from '../../utils/phoneUtils';
import './EditMemberModal.css';

const capitalizeFirstLetter = str => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const EditMemberModal = ({ onClose, onSave, member, roleOptions }) => {
  const initOpt = countryOptions.find(o =>
    member.Phone?.startsWith(o.code)
  ) || countryOptions[0];
  const initNational = stripCountryCode(member.Phone || '');

  const [name, setName] = useState(member?.Name || '');
  const [countryLabel, setCountryLabel] = useState(initOpt.label);
  const [phone, setPhone] = useState(initNational);
  const [selectedRole, setSelectedRole] = useState(member?.Roles?.toLowerCase() || '');
  const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
  const [phoneError, setPhoneError] = useState('');
  const [isActive, setIsActive] = useState(member?.Status?.toLowerCase() === 'active');

  const phoneErrMsg = validatePhoneNumber(countryLabel, phone);
  const isPhoneValid = phoneErrMsg === '';

  const handleSaveClick = () => {
    if (!name.trim() || !selectedRole) return;
    if (!isPhoneValid) {
      setPhoneError(phoneErrMsg);
      return;
    }

    const digits = phone.replace(/\D/g, '');
    const cc = extractCountryCode(countryLabel);
    const fullPhone = `${cc}${digits}`;
    const status = isActive ? 'active' : 'inactive';

    onSave(member, name.trim(), fullPhone, selectedRole.toLowerCase(), status);
    onClose();
  };

  return (
    <div className="edit-member-backdrop">
      <div className="edit-member-modal">
        <h2>Edit Member</h2>

        <div className="edit-member-input-group">
          <label className="edit-member-label">Name</label>
          <input
            type="text"
            placeholder="Enter member name"
            value={name}
            onChange={e => setName(e.target.value)}
            className="edit-member-input"
          />
        </div>

        <div className="edit-member-input-group">
          <label className="edit-member-label">Country/Region</label>
          <select
            className="edit-member-input"
            value={countryLabel}
            onChange={e => {
              setCountryLabel(e.target.value);
              setPhoneError('');
            }}
          >
            {countryOptions.map(o => (
              <option key={o.code + o.label} value={o.label}>
                {o.label}
              </option>
            ))}
          </select>
        </div>

        <div className="edit-member-input-group">
          <label className="edit-member-label">Phone</label>
          <input
            type="tel"
            value={phone}
            readOnly
            className="edit-member-input"
          />
        </div>

        <div className="edit-member-input-group">
          <label className="edit-member-label">Role</label>
          <div
            className="role-dropdown-trigger"
            onClick={() => setIsRoleDropdownOpen(open => !open)}
          >
            {selectedRole ? capitalizeFirstLetter(selectedRole) : 'Select Role'}
            <span className="dropdown-arrow">▼</span>
          </div>
          {isRoleDropdownOpen && (
            <div className="role-dropdown-options">
              {roleOptions.map(option => (
                <div
                  key={option}
                  className="role-option"
                  onClick={() => {
                    setSelectedRole(option.toLowerCase());
                    setIsRoleDropdownOpen(false);
                  }}
                >
                  {capitalizeFirstLetter(option)}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="edit-member-input-group">
          <label className="edit-member-checkbox-label">
            <input
              type="checkbox"
              checked={isActive}
              onChange={e => setIsActive(e.target.checked)}
              className="edit-member-checkbox"
            />
            Active
          </label>
        </div>

        <div className="edit-member-actions">
          <button onClick={onClose} className="edit-member-button cancel">
            Cancel
          </button>
          <button
            onClick={handleSaveClick}
            className="edit-member-button save"
            disabled={!isPhoneValid}
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditMemberModal;
